import(/* webpackMode: "eager" */ "/app/src/components/layout/footer/Footer.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/layout/navbar/index.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/layout/navbar/options/Product.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/layout/navbar/utils/StickyNavbar.tsx");
import(/* webpackMode: "eager" */ "/app/src/lib/hooks/useFloat.tsx");
import(/* webpackMode: "eager" */ "/app/src/lib/hooks/useNav.tsx")